import gql from 'graphql-tag';

export const operation = 'HomeUserInfo';
export const query = gql`
query ${operation} {
  userinfo {
    id
    self
    invites {
      id
      type
      self
      deal {
        self
        name
        status
        image
      }
      allocation {
        self
        documents {
          signed
        }
      }
    }
  }
}
`;

export function* sagas() {
  yield null;
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/home2/index.js